/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin:
      currentUser &&
      (currentUser.access === 'admin' ||
        currentUser.access === '超级管理员' ||
        currentUser.access === '普通管理员'),
  };
}
